module.exports = {
    currentProject: 'hssl'
};